import { render, staticRenderFns } from "./TournamentsMlbb.vue?vue&type=template&id=075e8490&scoped=true"
import script from "./TournamentsMlbb.vue?vue&type=script&lang=js"
export * from "./TournamentsMlbb.vue?vue&type=script&lang=js"
import style0 from "./TournamentsMlbb.vue?vue&type=style&index=0&id=075e8490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e8490",
  null
  
)

export default component.exports